import {RecordForm} from '../forms/RecordForm';


import {useApplication} from '../hooks/useApplication.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useApplication();

    return (
        <FormPageLayout
            title='Add Application'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/applications')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
